module.exports = __webpack_public_path__ + "static/media/VishSingh.e7d1099c.jpg";